export default {
  authorizationRequest: (state) => {
    state.authorizationStatus = 'awaiting'
  },
  authorizationSuccess: (state, token) => {
    state.authorizationStatus = 'success'
    state.token = token
  },
  authorizationError: (state) => {
    state.authorizationStatus = 'failure'
  },
  logout: (state) => {
    state.authorizationStatus = ''
    state.token = ''
  },
  localeChange: (state, code) => {
    state.locale = code
  },
  selectedSignatureProviderSubmission: (state, signatureProvider) => {
    state.selectedSignatureProvider = signatureProvider
  },
  setSignatureProviders: (state, providers) => {
    let signatureProviders = []
    let internalSignatureProviders = []
    providers.forEach(provider => {
      if (provider.internal === true) {
        internalSignatureProviders.push(provider)
      } else {
        signatureProviders.push(provider)
      }
    })
    state.signatureProviders = signatureProviders
    state.internalSignatureProviders = internalSignatureProviders
  },
  setUploadedDocument: (state, uploadedDocument) => {
    state.uploadedDocument = uploadedDocument
  },
  setUploadedDocumentInfo: (state, uploadedDocumentInfo) => {
    state.uploadedDocumentInfo = uploadedDocumentInfo
  },
  setshowPdfPrv: (state, payload) => {
    state.showPdfPrv = payload
  }
}
